<div class="h-100 w-100 d-flex justify-content-center py-2" 
  [class.align-content-center]="!navigationService.isMobileOrTablet()" >
  <div class="d-flex flex-row flex-wrap gap-4 justify-content-center">
    @for(card of cards; track $index) {
      @if(card.visible ||  card.visible === undefined) {
        <div>
          <div class="card" [style.backgroundImage]="'url(' + card.src + ')'" (click)="router.navigate(['dashboard', card.id])">
            <span class="card-title"> {{ card.title }}</span>
          </div>
        </div>
      }
    }
  </div>
</div>

<div *ngIf="formacionUrl" class="mt-2 mb-5 d-flex justify-content-center">
  <a [href]="formacionUrl" target="_blank" class="btn btn-primary btn-lg">
    Formación
    <i class="fa fa-external-link" style="font-size: 18px;"></i>
  </a>
</div>